import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { Box, Divider, Snackbar, Alert } from '@mui/material';
import '../../styles/customMediaQueries.css';
import css from './CarInfoCard.module.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Button } from '../../components';
import { createSaveQuery } from '../../util/api';
import { boltCircleSpellings } from '../../util/boltCircleCore';
import listingFieldContractCore from '../../util/listingFieldContractCore';
import { useConfiguration } from '../../context/configurationContext';
import { useDispatch } from 'react-redux';
import { getUserSavedQueries } from '../SearchPage/SearchPage.duck';


export function CarInfoCard(props) {
  const [activeIndex, setActiveIndex] = useState(null);
  const history = useHistory();
  const [initialParams, setInitialParams] = useState({});
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [successModalopen, setSuccessModalopen] = useState(false);
  const config = useConfiguration();

  const location = useLocation();
  const dispatch = useDispatch();

  // console.log(props?.data?.result)

  // useEffect(() => {
  //   // This will run once when the component mounts
  //   const frontRims = props?.data?.result?.original_tires?.front_rims || "";
  //   let extractedEt = frontRims.includes('ET')
  //     ? frontRims.split("ET")[1]
  //     : frontRims.includes('x')
  //     ? frontRims.split("x")[2]
  //     : "";

  //   extractedEt ||= props?.data?.car?.wheels?.[0]?.front?.rim_offset?.toString(10);  // Fallback logic

  //   // Log the extracted ET for debugging purposes
  //   console.log('Extracted ET:', extractedEt);

  //   // Clean up the ET string if any unwanted characters like "_5" are present
  //   if (extractedEt.includes('_')) {
  //     extractedEt = extractedEt.split('_')[0];  // Strip off any unwanted part after "_"
  //   }

  //   // Round ET to the nearest integer to avoid decimals (e.g., 40.5 should become 41)
  //   const parsedEt = Math.round(parseFloat(extractedEt));

  //   setEt(parsedEt);  // Set the initial 'et' value (rounded)
  // }, [props.data]);

  // useEffect(() => {
  //   // This effect will run once the `et` value is set
  //   if (etvalue !== null) {
  //     // Log the ET value
  //     console.log('ET value in second useEffect:', etvalue);

  //     // Calculate the ET range (from et-10 to et)
  //     const etRange = `${etvalue - 10},${etvalue}`;
  //     console.log('ET Range:', etRange);

  //     // URL encode the et range correctly (without extra characters)
  //     const encodedEtRange = encodeURIComponent(etRange); // Will encode the range like '-20,50' -> '-20%2C50'

  //     // Construct the URL params (including the ET range)
  //     let urlParams = {
  //       pub_etFront: encodedEtRange, 
  //       pub_boltCircle: props?.data?.result?.tire_info?.bolt_circle || "", 
  //       pub_categoryLevel1: props?.data?.car?.make?.name?.toLowerCase() || "",  
  //       // pub_categoryLevel2: props?.data?.car?.series?.name?.toLowerCase() || "",  
  //       pub_numberOfBolts: props?.data?.result?.tire_info?.bolts || "",  
  //     };

  //     // Log the params to check for issues
  //     console.log('URL Params before cleaning:', urlParams);

  //     // Clean up the urlParams and remove any empty or undefined parameters
  //     urlParams = Object.fromEntries(
  //       Object.entries(urlParams).filter(([_, value]) => value !== "" && value !== undefined)
  //     );

  //     // Log cleaned URL params
  //     console.log('Cleaned URL Params:', urlParams);

  //     // If you're on the 'search' page, update the search query
  //     if (props.page === 'search') {
  //       const filtersUrl = Object.entries(urlParams)
  //         .map(([key, value]) => `${key}=${value}`)
  //         .join('&')
  //         .replace(/\./g, '_') // Replace periods with underscores
  //         .replace(/-/g, 'n');  // Replace hyphens with 'n'

  //       // Log the final filters URL
  //       console.log('Filters URL:', filtersUrl);

  //       // Update the URL with the filters
  //       history.push({
  //         search: `?${filtersUrl}`,
  //       });
  //     }
  //   }
  // }, [etvalue]);\



  const captureInitialParams = () => {
    if (isFirstLoad) {
      const params = new URLSearchParams(window.location.search);
      const keys = [
        'pub_combination',
        'pub_boltCircle',
        'pub_numberOfBolts',
        'pub_categoryLevel1',
        'pub_categoryLevel2',
        'regNumber',
      ];

      const filteredParams = {};
      keys.forEach((key) => {
        const value = params.get(key);
        if (value !== null) {
          filteredParams[key] = value;
        }
      });

      setInitialParams(filteredParams);
      setIsFirstLoad(false);
      // console.log('Initial parameters captured:', filteredParams);
    }
  };
  useEffect(() => {
    captureInitialParams();
  }, []);


  const getOwnListingSearch = () => {
    const queryString = typeof window !== 'undefined' && window.location.search;
    const urlParamsPrevious = new URLSearchParams(queryString);
    const searchType = urlParamsPrevious?.get("searchType")
    const ownListingsMaybe = searchType == "ownListing" ? { searchType: "searchType=ownListing" } : {}
    return ownListingsMaybe
  }

  let center_bore_from_api = props?.data?.result?.tire_info?.center_bore?.toString(10);
  center_bore_from_api ||= props?.data?.car?.technical?.centre_bore?.toString(10);
  center_bore_from_api ||= props?.data?.data?.[0]?.technical?.centre_bore?.toString(10);


  const center_bore = center_bore_from_api?.replace('.', '_');

  /* The listing form stores ONE Console option key (P25009-470). The `fields`
   * each click handler builds also make the search URL, where every spelling
   * of a bolt circle is sent as an OR ("114.3,114_3,1143") — copied into the
   * form, that list was saved on wizard listings as their bolt circle. So the
   * form gets Console's key, and a value no option means (a 66.56 mm bore)
   * leaves the field empty for the seller to choose.
   *
   * A value the click does not know is left out rather than written empty: the
   * rim view passes no bolt circle or bolt count, and writing '' wiped the 5x108
   * the plate lookup had just filled. */
  const fieldRegistry = listingFieldContractCore.buildFieldRegistry(
    config?.listing?.listingFields || []
  );
  const consoleKey = (key, value) =>
    value === undefined || value === null || value === ''
      ? ''
      : listingFieldContractCore.toConsoleOption(fieldRegistry.fields.get(key), String(value)) ||
        '';
  const toFormValues = (fields, boltCircle) =>
    Object.fromEntries(
      Object.entries({
        ...fields,
        ...('pub_boltCircle' in fields ? { pub_boltCircle: consoleKey('boltCircle', boltCircle) } : {}),
        ...('pub_hubHole' in fields ? { pub_hubHole: consoleKey('hubHole', center_bore_from_api) } : {}),
      }).filter(([, value]) => value !== '')
    );
  // const model_year = `${props?.data?.result?.model_year ?? ''}`;
  const model_year =
    props?.data?.result?.model_year ??
    props?.data?.car?.end_year ??
    (Array.isArray(props?.data?.data) && props?.data?.data[0]?.end_year) ??
    "";

  const saveLastQuery = async () => {

    setLoading(true);
    try {
      const searchParams = new URLSearchParams(location.search);

      const excludeKeys = ["searchType", "page", "selectedUserId", "stock", "regNumber"];

      const finalParams = {};
      const make =
        props?.data?.car?.make?.name_en ??
        (Array.isArray(props?.data?.data) && props?.data?.data[0]?.make?.name_en) ??
        finalParams?.pub_categoryLevel1 ??
        "";

      const model =
        props?.data?.car?.model?.name_en ??
        (Array.isArray(props?.data?.data) && props?.data?.data[0]?.model?.name_en) ??
        finalParams?.pub_categoryLevel2 ??
        "";
      for (const [key, value] of searchParams.entries()) {
        if (!excludeKeys.includes(key) && value.trim() !== "") {
          finalParams[key] = value;
        }
      }
      if (et) {
        const etValue = Number(et);
        if (!isNaN(etValue)) {
          const etRange = `${etValue - 10},${etValue}`;
          finalParams.pub_etFront = etRange;
        }
      }

      if (center_bore_from_api) {
        finalParams.pub_hubHole = center_bore_from_api;
      }


      const title =
        [make, model, model_year]
          .filter(Boolean)
          .join(" ") ||
        [initialParams?.pub_categoryLevel1, initialParams?.pub_categoryLevel2]
          .filter(Boolean)
          .join(" ");

      const body = {
        savedQuery: {
          title,
          ...(initialParams?.regNumber ? { regNumber: initialParams.regNumber } : {}),
          params: finalParams,
        },
      };

      await createSaveQuery(body);
      setSuccessModalopen(true);
      dispatch(getUserSavedQueries());
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false);
    }
  };


  const handleWheelClick = (str, boltCircle, numOfBolts, index, brand, model, motor, title) => {
    const pattern = /(\d+)\/(\d+)(Z?R)(\d+)/;
    const match = str.match(pattern);
    const ownListingsMaybe = getOwnListingSearch();

    if (match) {
      let urlParams = {};
      let pureUrlParams = {};

      if (props.currentTab === 0 || props.currentTab === 1) {
        // const formattedTitle = `${brand ?? ''} ${model ?? ''} ${model_year} ${parseInt(match[1], 10)}`;
        const formattedTitle = `${brand ?? ''} ${model ?? ''} ${motor ?? ''}`;
        console.log('formattedTitle', formattedTitle);
        const finalTitle = formattedTitle.trim() === '' ? title : formattedTitle;
        console.log('finalTitle', finalTitle)
        // Every stored spelling, Console's key "1397" included (P25009-488).
        const formattedBoltCircle = boltCircle ? boltCircleSpellings(boltCircle).join(',') || String(boltCircle).replace('.', '_') : '';
        const fields = {
          pub_tireWidthFront: `${parseInt(match[1], 10)}`,
          pub_profileFront: `${parseInt(match[2], 10)}`,
          pub_diameter: `${parseInt(match[4], 10)}`,
          pub_numberOfBolts: `${numOfBolts ?? ''}`,
          // pub_boltCircle: `${boltCircle ?? ''}`,
          pub_boltCircle: formattedBoltCircle,
          pub_hubHole: `${center_bore ?? ''}`,
          pub_adType: 'wheel',
          title: finalTitle,
        };
        props.formApi?.batch(() => {
          Object.entries(toFormValues(fields, boltCircle)).forEach(([key, value]) => {
            props.formApi.change(key, value);
          });
        });
        pureUrlParams = {
          tireWidthFront: `pub_tireWidthFront=${fields.pub_tireWidthFront}`,
          profileFront: `pub_profileFront=${fields.pub_profileFront}`,
          diameter: `pub_diameter=${fields.pub_diameter}`,
          numOfBolts: `pub_numberOfBolts=${fields.pub_numberOfBolts}`,
          boltCircle: `pub_boltCircle=${fields.pub_boltCircle}`,
          carBrandCategory: `pub_categoryLevel1=${brand?.toLowerCase() ?? ''}`,
          carModelCategory: `pub_categoryLevel2=${model?.toLowerCase()?.replace(/\s+/g, '') ?? ''}`,
          productType: `pub_adType=${fields.pub_adType}`,
          // ...ownListingsMaybe,
        };
        urlParams = {
          ...pureUrlParams,
          ...ownListingsMaybe,
        };
        // const saveParams = {
        //   pub_tireWidthFront: fields.pub_tireWidthFront,
        //   pub_profileFront: fields.pub_profileFront,
        //   pub_diameter: fields.pub_diameter,
        //   pub_numberOfBolts: fields.pub_numberOfBolts,
        //   pub_boltCircle: fields.pub_boltCircle,
        //   pub_hubHole: fields.pub_hubHole,
        //   pub_categoryLevel1: brand?.toLowerCase(),
        //   pub_categoryLevel2: model?.toLowerCase()?.replace(/\s+/g, ''),
        //   pub_adType: fields.pub_adType,
        //   // ...ownListingsMaybe
        // };

        // // Filter out empty values
        // const finalsaveParams = Object.fromEntries(
        //   Object.entries(saveParams).filter(
        //     ([, value]) => value !== undefined && value !== null && value !== ''
        //   )
        // );
        // setLastQuery({
        //   title: [brand, model].filter(Boolean).join(" ")
        //     || [initialParams?.pub_categoryLevel1,
        //     initialParams?.pub_categoryLevel2]
        //       .filter(Boolean)
        //       .join(" "), params: finalsaveParams
        // });
      } else {
        urlParams = {
          diameter: `pub_diameter=${parseInt(match[4], 10)}`,
        };
      }

      const filtersUrl = Object.values(urlParams)
        .join('&')
        .replace(/\./g, '_')
        .replace(/-/g, 'n');

      if (props.page === 'search') {
        history.push({
          search: `?${filtersUrl}`,
        });
      }
      if (props.listingType === 'buying' && props.setBuyingFormStep) {
        props.setBuyingFormStep(2);
      }
    } else {
      return { tireWidth: '', profile: '', diameter: '' };
    }
    setActiveIndex(activeIndex === `${props.type}-${index}` ? null : `${props.type}-${index}`);
  };

  const handleTireClick = (str, index, brand, model, motor) => {
    const pattern = /(\d+)\/(\d+)(Z?R)(\d+)/;
    const match = str.match(pattern);
    const ownListingsMaybe = getOwnListingSearch();

    if (match) {
      // const formattedTitle = `${brand ?? ''} ${model ?? ''} ${model_year} ${parseInt(match[1], 10)}`;
      const formattedTitle = `${brand ?? ''} ${model ?? ''} ${motor ?? ''}`;

      let urlParams = {};
      let pureUrlParams = {};

      if (props.currentTab === 0 || props.currentTab === 1) {
        const fields = {
          pub_tireWidthFront: `${parseInt(match[1], 10)}`,
          pub_profileFront: `${parseInt(match[2], 10)}`,
          pub_diameter: `${parseInt(match[4], 10)}`,
          pub_hubHole: `${center_bore ?? ''}`,
          pub_adType: 'tire',
          title: formattedTitle,
        };

        props.formApi?.batch(() => {
          Object.entries(toFormValues(fields)).forEach(([key, value]) => {
            props.formApi.change(key, value);
          });
        });

        pureUrlParams = {
          tireWidthFront: `pub_tireWidthFront=${fields.pub_tireWidthFront}`,
          // tireWidthRear: `pub_tireWidthRear=${parseInt(match[1], 10)}`,
          profileFront: `pub_profileFront=${fields.pub_profileFront}`,
          // profileRear: `pub_profileRear=${parseInt(match[2], 10)}`,
          diameter: `pub_diameter=${fields.pub_diameter}`,
          // Commented the following two params out because we don't want to show the brand or category
          // carBrandCategory: `pub_categoryLevel1=${brand.toLowerCase()}`,
          // carModelCategory: `pub_categoryLevel2=${model.toLowerCase().replace(/\s+/g, '')}`,
          productType: `pub_adType=${fields.pub_adType}`,
          // ...ownListingsMaybe,
        };
        urlParams = {
          ...pureUrlParams,
          ...ownListingsMaybe,
        };
      } else {
        urlParams = {
          diameter: `pub_diameter=${parseInt(match[4], 10)}`,
        };
      }

      const filtersUrl = Object.values(urlParams)
        .join('&')
        .replace(/\./g, '_')
        .replace(/-/g, 'n');

      if (props.page === 'search') {
        history.push({
          search: `?${filtersUrl}`,
        });
      }
      if (props.listingType === 'buying' && props.setBuyingFormStep) {
        props.setBuyingFormStep(2);
      }
    } else {
      return { tireWidth: '', profile: '', diameter: '' };
    }
    setActiveIndex(activeIndex === `tire-${index}` ? null : `tire-${index}`);
  };

  const handleRimClick = (str, boltCircle, numOfBolts, index, brand, model, motor) => {
    // The car data writes rims "8JX18" as well as "8Jx18".
    const match = str.match(/x(\d{2})/i);
    const diameter = match ? match[1] : null;
    const ownListingsMaybe = getOwnListingSearch();
    // Every stored spelling, Console's key "1397" included (P25009-488).
    const formattedBoltCircle = boltCircle ? boltCircleSpellings(boltCircle).join(',') || String(boltCircle).replace('.', '_') : '';
    const formattedTitle = `${brand ?? ''} ${model ?? ''} ${motor ?? ''}`;

    const fields = {
      pub_numberOfBolts: `${numOfBolts ?? ''}`,
      // pub_boltCircle: `${boltCircle ?? ''}`,
      pub_boltCircle: formattedBoltCircle,
      pub_diameter: `${diameter ?? ''}`,
      pub_hubHole: `${center_bore ?? ''}`,
      pub_adType: 'rim',
      title: formattedTitle,
    };


    props.formApi?.batch(() => {
      Object.entries(toFormValues(fields, boltCircle)).forEach(([key, value]) => {
        props.formApi.change(key, value);
      });
    });

    let pureUrlParams = {
      numOfBolts: `pub_numberOfBolts=${fields.pub_numberOfBolts}`,
      boltCircle: `pub_boltCircle=${fields.pub_boltCircle}`,
      diameter: `pub_diameter=${fields.pub_diameter}`,
      carBrandCategory: `pub_categoryLevel1=${brand?.toLowerCase() ?? ''}`,
      carModelCategory: `pub_categoryLevel2=${model?.toLowerCase()?.replace(/\s+/g, '') ?? ''}`,
      productType: `pub_adType=${fields.pub_adType}`,
      // ...ownListingsMaybe,
    };
    let urlParams = {
      ...pureUrlParams,
      ...ownListingsMaybe,
    };

    const filtersUrl = Object.values(urlParams)
      .join('&')
      .replace(/\./g, '_')
      .replace(/-/g, 'n');

    if (props.page === 'search') {
      history.push({
        search: `?${filtersUrl}`,
      });
      if (props.listingType === 'buying' && props.setBuyingFormStep) {
        props.setBuyingFormStep(2);
      }
    }
    setActiveIndex(activeIndex === `rim-${index}` ? null : `rim-${index}`);
  };

  const isItemSelected = (itemData, listType, index) => {
    // 1. Check local state first (most specific)
    if (activeIndex === `${listType}-${index}`) {
      return true;
    }

    // 2. If no local selection, fallback to form values (for persistence/reload)
    if (!activeIndex && props.values) {
      const v = props.values;
      
      // Map wizard productType to CarInfoCard listTypes
      const isWheelTab = v.productType === 'komplett' && (listType === 'wheel' || listType === 'wheel_wide');
      const isTireTab = v.productType === 'dack' && listType === 'tire';
      const isRimTab = v.productType === 'falg' && listType === 'rim';

      if (isWheelTab || isTireTab || isRimTab) {
        if (listType === 'tire' || listType === 'wheel' || listType === 'wheel_wide') {
          const pattern = /(\d+)\/(\d+)(Z?R)(\d+)/;
          const match = itemData.match(pattern);
          if (match) {
            const w = parseInt(match[1], 10);
            const p = parseInt(match[2], 10);
            const d = parseInt(match[4], 10);
            return (
              String(v.tireWidthFront) === String(w) &&
              String(v.profileFront) === String(p) &&
              String(v.diameter) === String(d)
            );
          }
        }
        if (listType === 'rim') {
          const match = itemData.match(/x(\d{2})/);
          const d = match ? match[1] : null;
          if (d) {
            return String(v.diameter) === String(d);
          }
        }
      }
    }

    return false;
  };

  const handleBrandModelClick = () => {
    // const brand = car.brand ? car.brand : car?.make?.name;
    // const model = car?.series?.name ? car.series.name : car?.series ? car.series : car?.model?.name;

    const ownListingsMaybe = getOwnListingSearch();

    let urlParams = {
      //   carBrandCategory: `pub_categoryLevel1=${brand.toLowerCase()}`,
      // carModelCategory: `pub_categoryLevel2=${model.toLowerCase().replace(/\s+/g, '')}`,
      ...initialParams,
      ...ownListingsMaybe,
    };



    // const filtersUrl = Object.values(urlParams)
    //   .join('&')
    //   .replace(/\./g, '_') 
    //   .replace(/-/g, 'n'); 
    // if (props.page === 'search') {
    //   history.push({
    //     search: `?${filtersUrl}`,
    //   });
    // }

    const filtersUrl = Object.entries(urlParams)
      .map(([key, value]) => {

        if (key === 'searchType') {
          return `${value}`;
        }

        return `${key}=${value}`;

      })
      .join('&')
      .replace(/\./g, '_')
      .replace(/-/g, 'n');

    if (props.page === 'search') {
      history.push({
        search: `?${filtersUrl}`,
      });
    }
  };


  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const List = props => {
    return (
      <Box
        component={'div'}
        sx={{
          padding: '0px 0px 10px 20px',
        }}
      >
        {isMobile ? (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel-content"
              id="panel-header"
            >
              <h3
                style={{
                  fontWeight: 'var(--fontWeightMedium)',
                  fontSize: '21px',
                  lineHeight: '33.6px',
                  margin: '0px',
                }}
              >
                {props.type === 'wheel' ? (
                  <p style={{ margin: "1px 0 7px 0", fontSize: '21px', fontWeight: "var(--fontWeightMedium)", lineHeight: '25.6px' }}>
                    Hjul</p>
                ) : props.type === 'wheel_wide' ? (
                  <p style={{ margin: "1px 0 7px 0", fontSize: '21px', fontWeight: "var(--fontWeightMedium)", lineHeight: '25.6px' }}>
                    Hjul Brett</p>
                )
                  : props.type === 'tire' ? (
                    <p style={{ margin: "1px 0 7px 0", fontSize: '21px', fontWeight: "var(--fontWeightMedium)", lineHeight: '25.6px' }}>
                      Däck</p>
                  ) : (
                    <p style={{ margin: "1px 0 7px 0", fontSize: '21px', fontWeight: "var(--fontWeightMedium)", lineHeight: '25.6px' }}>
                      Fälg</p>
                  )}
              </h3>
            </AccordionSummary>
            <AccordionDetails>
              {props.listItems.data.map((entry, entryIndex) => {
                return entry.data.map((data, index) => (
                  <p
                    key={`${entryIndex}-${index}`}
                    onClick={
                      props.type === 'wheel'
                        ? () =>
                          handleWheelClick(
                            data,
                            props.boltCircle,
                            props.numOfBolts,
                            index,
                            props.brand,
                            // props.series
                            props.model,
                            props.motor
                          ) :
                        props.type === 'wheel_wide'
                          ? () =>
                            handleWheelClick(
                              data,
                              props.boltCircle,
                              props.numOfBolts,
                              index,
                              '',
                              '',
                              '',
                              title
                            )

                          : props.type === 'tire'
                            ? () => handleTireClick(data, index, props.brand, props.model, props.motor)
                            : () =>
                              handleRimClick(
                                data,
                                props.boltCircle,
                                props.numOfBolts,
                                index,
                                props.brand,
                                // props.series
                                props.model,
                                props.motor
                              )
                    }
                    className={classNames(css.arrayListItem, { [css.clicked]: isItemSelected(data, props.type, index) })}
                  >
                    {data.replaceAll('.00', '')}
                  </p>
                ));
              })}
            </AccordionDetails>
          </Accordion>
        ) : (
          <>
            <h3
              style={{
                fontWeight: 'var(--fontWeightMedium)',
                fontSize: '21px',
                lineHeight: '33.6px',
                margin: '0px',
              }}
            >
              {props.type === 'wheel' ? (
                <p>Hjul</p>
              ) :
                props.type === 'wheel_wide' ? (
                  <p>Hjul Brett</p>
                ) :
                  props.type === 'tire' ? (
                    <p>Däck</p>
                  ) : (
                    <p>Fälg</p>
                  )}
            </h3>

            {props.listItems.data.map((entry, entryIndex) => {
              return entry.data.map((data, index) => (
                <p
                  key={`${entryIndex}-${index}`}
                  onClick={
                    props.type === 'wheel'
                      ? () =>
                        handleWheelClick(
                          data,
                          props.boltCircle,
                          props.numOfBolts,
                          index,
                          props.brand,
                          // props.series
                          props.model,
                          props.motor

                        ) :
                      props.type === 'wheel_wide'
                        ? () =>
                          handleWheelClick(
                            data,
                            props.boltCircle,
                            props.numOfBolts,
                            index,
                            '',
                            '',
                            '',
                            title
                          )

                        : props.type === 'tire'
                          ? () => handleTireClick(data, index, props.brand, props.model, props.motor)
                          : () =>
                            handleRimClick(
                              data,
                              props.boltCircle,
                              props.numOfBolts,
                              index,
                              props.brand,
                              // props.series
                              props.model,
                              props.motor
                            )
                  }
                  className={classNames(css.arrayListItem, { [css.clicked]: isItemSelected(data, props.type, index) })}
                >
                  {data.replaceAll('.00', '')}
                </p>
              ));
            })}
          </>
        )}
      </Box>
    );
  }

  let data;
  let car = {};
  let rim = {};
  let tire = {};
  let wheel = {};

  if (props.formType === 'licensePlate') {
    car = props?.data?.result || props?.data?.data[0];
    let frontTires = [];
    let rearTires = [];
    let frontRims = [];
    let rearRims = [];

    if (car.wheels) {
      // Handle case where we have `wheels`
      car.wheels.forEach(wheel => {
        if (wheel.front?.tire) {
          frontTires.push(wheel.front.tire);
        }
        if (wheel.rear?.tire) {
          rearTires.push(wheel.rear.tire);
        }
        if (wheel.front?.rim) {
          frontRims.push(wheel.front.rim);
        }
        if (wheel.rear?.rim) {
          rearRims.push(wheel.rear.rim);
        }
      });
    } else if (car.tire_info && car.tire_info.tires) {
      // Handle case where we have `tire_info.tires`
      car.tire_info.tires.forEach(tire => {
        if (tire.front?.tire) {
          frontTires.push(tire.front.tire);
        }
        if (tire.rear?.tire) {
          rearTires.push(tire.rear.tire);
        }
        if (tire.front?.rim) {
          frontRims.push(tire.front.rim);
        }
        if (tire.rear?.rim) {
          rearRims.push(tire.rear.rim);
        }
      });
    } else {
      console.error('Invalid data structure: No tires or wheels data found');
      return;
    }

    // const allFrontTires = [...new Set(frontTires)];
    // const allRearTires = [...new Set(rearTires)];
    // const allFrontRims = [...new Set(frontRims)];
    // const allRearRims = [...new Set(rearRims)];


    // const allFrontTires = [...new Set([...frontTires, car.original_tires.front_tires])];
    // const allRearTires = [...new Set([...rearTires, car.original_tires.rear_tires])];
    // const allFrontRims = [...new Set([...frontRims, car.original_tires.front_rims])];
    // const allRearRims = [...new Set([...rearRims, car.original_tires.rear_rims])];

    // If original_tires are available, merge them with front and rear tires/rims
    const allFrontTires = [
      ...new Set([
        ...frontTires,
        ...(car?.original_tires?.front_tires ? [car.original_tires.front_tires] : [])
      ])
    ];

    const allRearTires = [
      ...new Set([
        ...rearTires,
        ...(car?.original_tires?.rear_tires ? [car.original_tires.rear_tires] : [])
      ])
    ];

    const allFrontRims = [
      ...new Set([
        ...frontRims,
        ...(car?.original_tires?.front_rims ? [car.original_tires.front_rims] : [])
      ])
    ];

    const allRearRims = [
      ...new Set([
        ...rearRims,
        ...(car?.original_tires?.rear_rims ? [car.original_tires.rear_rims] : [])
      ])
    ];

    // console.log("All Front Tires:", allFrontTires);
    // console.log("All Rear Tires:", allRearTires);
    // console.log("All Front Rims:", allFrontRims);
    // console.log("All Rear Rims:", allRearRims);



    const allTires = [...new Set([...allFrontTires, ...allRearTires])];
    const allRims = [...new Set([...allFrontRims, ...allRearRims])];


    rim = {
      data: [{ title: 'Fälg', data: allRims }],
    };
    tire = {
      data: [{ title: 'Däck', data: allTires }],
    };
    wheel = {
      data: [{ title: 'Hjul', data: allTires }],
    };
  } else {
    car = props.data.car;
    let frontTires = [];
    let rearTires = [];
    let frontRims = [];
    let rearRims = [];

    car.wheels.map(tire => {
      frontTires.push(tire.front.tire);
      rearTires.push(tire.rear.tire);
      frontRims.push(tire.front.rim);
      rearRims.push(tire.rear.rim);
    });

    //For some reason rear wheel data is missing from wheelsize api therefore the removal of empty entries is necessary
    const allTires = [...new Set([...frontTires, ...rearTires])].filter(tire => tire !== '');
    const allRims = [...new Set([...frontRims, ...rearRims])].filter(tire => tire !== '');

    rim = {
      data: [{ title: 'Fälg', data: allRims }],
    };
    tire = {
      data: [{ title: 'Däck', data: allTires }],
    };
    wheel = {
      data: [{ title: 'Hjul', data: allTires }],
    };
  }

  if (props.listingType === 'rim') {
    data = rim;
  } else if (props.listingType === 'tire') {
    data = tire;
  }

  const tireInfo = props?.data?.result?.tire_info || props?.data?.car || (props?.data?.data ? props?.data?.data[0] : {}) || {};

  const {
    bolts = tireInfo?.technical?.stud_holes || tireInfo.bolts || "",
    bolt_circle = tireInfo?.technical?.pcd || tireInfo.bolt_circle || "",
  } = tireInfo;


  const frontRims = (props?.data?.result?.original_tires?.front_rims) ||
    (props?.data?.data?.[0]?.wheels?.[0]?.front?.rim) || "";
  let et = frontRims.includes('ET') ? frontRims.split("ET")[1] : frontRims.includes('x') ? frontRims.split("x")[2] : "";
  et ||= props?.data?.car?.wheels?.[0]?.front?.rim_offset?.toString(10);

  et = et?.replaceAll(" ", "")

  const title = `${car.brand ? car.brand : car?.make?.name} ${car?.series?.name ? car.series.name : car?.series ? car.series : car?.model?.name} ${car?.name || ''}`;

  return (
    <Box
      component="section"
      width="100%"
      backgroundColor="white"
      borderRadius="10px"
      sx={{
        marginBottom: '20px',
        '@media (min-width: 430px)': {
          marginTop: '10px',
        },
      }}
    >
      <Accordion defaultExpanded={!isMobile}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel-content"
          id="panel-header"
        >
          <h2 className={css.carDetailHeading}>
            {props.formType === 'licensePlate' ? (
              <>
                {
                  car.brand && car.sales_name
                    ? `${car.brand} ${car.sales_name}`
                    : `${car?.make?.name || ''} ${car?.series?.name || car?.model?.name || ''} ${car?.name || ''}`
                }
              </>
            ) : (
              <>
                {car.make?.name} {car.series?.name ? car.series?.name : car.model?.name} {car?.name}
              </>
            )}
          </h2>
        </AccordionSummary>
        <Box
          sx={{ padding: '16px' }}
        >
          <div className={css.extraSpecTitle}>
            <FormattedMessage id="CarInfoCard.extraSpecTitle" />
          </div>
          <div className={css.extraSpecContent}>
            {bolts ? <div className={css.extraSpecItem}>
              {bolts} bultar
            </div> : null}
            {bolt_circle ? <div className={css.extraSpecItem}>
              <b><FormattedMessage id="CarInfoCard.extraSpec.boltPattern" /></b>
              {bolt_circle} mm
            </div> : null}
            {center_bore_from_api ? <div className={css.extraSpecItem}>
              <b><FormattedMessage id="CarInfoCard.extraSpec.centerBore" /></b>
              {center_bore_from_api} mm
            </div> : null}
            {et ? <div className={css.extraSpecItem}>
              <b><FormattedMessage id="CarInfoCard.extraSpec.et" /></b>
              range  {Number(et) - 10}-{et} mm
            </div> : null}
          </div>
        </Box>
        <AccordionDetails>
          <Divider
            sx={{
              marginBottom: '10px',
              '@media (min-width: 767px)': {
                maxWidth: '40%',
              },
            }}
          />
          <div className={css.flexContent}>
            <div onClick={handleBrandModelClick}
              className={css.carBrandFilter}
            >        {props.formType === 'licensePlate' ? (
              <>
                <>
                  {
                    car.brand && car.sales_name
                      ? `${car.brand} ${car.sales_name}`
                      : `${car?.make?.name || ''} ${car?.series?.name || car?.model?.name || ''} ${car?.name || ''}`
                  }
                </>

              </>

            ) : (
              <>
                {car?.make?.name} {car.series?.name ? car.series?.name : car?.model?.name} {car?.name}
              </>
            )}</div>
            {props.page === 'search' ?
              props.editingQueryId ?
                // <Button
                //   onClick={props.handleUpdateSavedQuery}
                //  className={css.saveButton}
                //   inProgress={props.updateSavedQueryInProgress}
                //   disabled={props.updateSavedQueryInProgress}
                // >Uppdatera fråga</Button>
                null
                : <Button
                  onClick={() => saveLastQuery()}
                  className={css.saveButton}
                  disabled={loading}
                  inProgress={loading}
                >
                 Spara bil
                </Button>
              : null}
            <Snackbar
              open={successModalopen}
              autoHideDuration={3000} // auto close in 3s
              onClose={() => setSuccessModalopen(false)}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
              <Alert
                onClose={() => setSuccessModalopen(false)}
                severity="success"
                variant="filled"
                sx={{
                  width: "100%",
                }}
              >
                Bilen har räddats.
              </Alert>
            </Snackbar>
          </div>
          <Box
            sx={{
              '@media (min-width: 767px)': {
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
              },
            }}
          >
            {props.listingType === 'tire' || props.listingType === 'rim' ? (
              <List listItems={data} brand={car.brand} type={props.listingType} />
            ) : (
              <>
                <List
                  listItems={wheel}
                  type="wheel"
                  page={props.page}
                  brand={car.brand ? car.brand : car?.make?.name}
                  model={car?.series?.name ? car.series.name : car?.series ? car.series : car?.model?.name}
                  boltCircle={
                    car.tire_info?.bolt_circle ? car.tire_info.bolt_circle : car.technical ? car.technical.pcd : ''
                  }
                  numOfBolts={car.tire_info?.bolts ? car.tire_info.bolts : car.technical ? car.technical.stud_holes : ''}
                  motor={car?.name}
                />
                <List
                  listItems={wheel}
                  type="wheel_wide"
                  page={props.page}
                  boltCircle={
                    car.tire_info?.bolt_circle ? car.tire_info.bolt_circle : car.technical ? car.technical.pcd : ''
                  }
                  numOfBolts={car.tire_info?.bolts ? car.tire_info.bolts : car.technical ? car.technical.stud_holes : ''}
                  title={title}
                />
                <List
                  listItems={tire}
                  type="tire"
                  page={props.page}
                  brand={car.brand ? car.brand : car?.make?.name}
                  model={car?.series?.name ? car.series.name : car?.series ? car.series : car?.model?.name}
                  motor={car?.name}

                />
                <List
                  listItems={rim}
                  type="rim"
                  page={props.page}
                  brand={car.brand ? car.brand : car?.make?.name}
                  model={car?.series?.name ? car.series.name : car?.series ? car.series : car?.model?.name}
                  boltCircle={
                    car.tire_info?.bolt_circle ? car.tire_info.bolt_circle : car.technical ? car.technical.pcd : ''
                  }
                  numOfBolts={car.tire_info?.bolts ? car.tire_info.bolts : car.technical ? car.technical.stud_holes : ''}
                  motor={car?.name}
                />
              </>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
